// The three states every table has to be able to show (§8.3): loading, empty,
// error. An empty table with no explanation is never shown.

import type { ReactNode } from 'react'

export function Loading({ rows = 5 }: { rows?: number }) {
  return (
    <div className="animate-pulse space-y-2 p-4" role="status" aria-label="caricamento">
      {Array.from({ length: rows }, (_, i) => (
        <div key={i} className="h-8 rounded bg-slate-100" />
      ))}
    </div>
  )
}

export function Empty({ title, hint }: { title: string; hint?: string }) {
  return (
    <div className="p-10 text-center">
      <p className="text-sm font-medium text-slate-700">{title}</p>
      {hint && <p className="mt-1 text-sm text-slate-500">{hint}</p>}
    </div>
  )
}

export function ErrorState({ error, onRetry }: { error: unknown; onRetry?: () => void }) {
  const message = error instanceof Error ? error.message : 'errore imprevisto'
  return (
    <div className="p-10 text-center" role="alert">
      <p className="text-sm font-medium text-rose-700">Non sono riuscito a caricare i dati.</p>
      <p className="mt-1 text-sm text-slate-500">{message}</p>
      {onRetry && (
        <button
          type="button"
          onClick={onRetry}
          className="mt-4 rounded-md bg-slate-800 px-3 py-1.5 text-sm text-white hover:bg-slate-700"
        >
          Riprova
        </button>
      )}
    </div>
  )
}

interface CardProps {
  title?: string
  actions?: ReactNode
  children: ReactNode
  className?: string
}

export function Card({ title, actions, children, className = '' }: CardProps) {
  return (
    <section className={`rounded-lg border border-slate-200 bg-white shadow-sm ${className}`}>
      {(title || actions) && (
        <header className="flex items-center justify-between border-b border-slate-100 px-4 py-3">
          {title && <h2 className="text-sm font-semibold text-slate-800">{title}</h2>}
          {actions}
        </header>
      )}
      {children}
    </section>
  )
}
